<template>
  <div>
    <div class="add-container">
      <el-input v-model.trim="searchVal" placeholder="请输入姓名或手机号" class="search-input" clearable>
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <!-- :disabled="isPermissionDisabled('DCP-ME-P')" -->
      <el-button v-if="!isPermissionDisabled(`DCP-ME-P-${theme.toUpperCase()}`)" type="primary" class="add-btn" @click="addUser">新增员工</el-button>
    </div>

    <ul v-show="dataReady" class="user-list flex-between">
      <li v-for="(item, index) in list" :key="index" @click="checkStaffInfo(item)">
        <div v-show="item" class="user-item flex-center-between">
          <div class="user-avatar-wrap flex-center"><span class="iconfont user-avatar">&#xe8a2;</span></div>
          <div class="info-wrap">
            <p class="flex-center-start info-title one_txt_cut">
              <span class="user-name one_txt_cut">{{ item.nickname }}</span>
              <span class="role">{{ item.roleName }}</span>
            </p>
            <p class="phone one_txt_cut">{{ item.loginCode }}</p>
          </div>
        </div>
      </li>
      <li v-show="!list.length" class="empty-wrap">
        <img src="../../../assets/img/icon-empty.png" class="empty" alt="">
      </li>
    </ul>

    <!-- 员工信息 -->
    <UserInfo :is-show.sync="isShowStaffInfo" :data="currStaffInfo" />
    <!-- 添加员工 -->
    <AddUser :is-show.sync="isShowAddUser" :dialog-status="dialogStatus" :staff-data="staffData" />

    <!-- 权限列表 -->
    <el-dialog
      title=""
      :visible.sync="isShowPermissionList"
      width="1200px"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >

      <el-tabs v-model="activeName">
        <el-tab-pane label="PC" name="PC">
          <ul class="permission-list-wrap">
            <li v-for="item in staffData.roles" v-show="item.deviceTypeAppNames && item.deviceTypeAppNames.PC && item.deviceTypeAppNames.PC.length" :key="item.rolePk" class="permission-item flex-center">
              <div class="role-name">{{ item.roleName }}</div>
              <div class="app-wrap">
                <span v-for="(child, childIndex) in item.deviceTypeAppNames && item.deviceTypeAppNames.PC" :key="childIndex" class="app-item">{{ child }}</span>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="MOBILE" name="MOBILE">
          <ul class="permission-list-wrap">
            <li v-for="item in staffData.roles" v-show="item.deviceTypeAppNames && item.deviceTypeAppNames.MOBILE && item.deviceTypeAppNames.MOBILE.length" :key="item.rolePk" class="permission-item flex-center">
              <div class="role-name">{{ item.roleName }}</div>
              <div class="app-wrap">
                <span v-for="(child, childIndex) in item.deviceTypeAppNames && item.deviceTypeAppNames.MOBILE" :key="childIndex" class="app-item">{{ child }}</span>
              </div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>

  </div>
</template>

<script>
import UserInfo from './UserInfo'
import AddUser from './AddUser'

export default {
  name: 'User',
  provide() {
    return {
      userParent: this
    }
  },
  components: { UserInfo, AddUser },
  data() {
    return {
      loadingComponent: null,
      isLoading: false,
      isBtnLoading: false,
      searchVal: '',
      staffList: [],
      list: [],
      isShowStaffInfo: false,
      currStaffInfo: {},
      isShowAddUser: false,
      dialogStatus: 'create',
      staffData: {},
      dataReady: false,
      isShowPermissionList: false,
      activeName: 'PC',
      limitVo: {}
    }
  },
  computed: {
    theme() {
      return this.$store.getters.theme
    },
    isPermissionDisabled() {
      return function(val) {
        const list = this.$store.getters.currApps.SET || []
        const data = list.filter(item => item.applicationId === val)

        return !data.length
      }
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    isBtnLoading(newValue) {
      if (newValue) {
        this.loadingComponent = this.$loading({
          lock: this.isMobile,
          spinner: 'blank',
          background: 'rgba(0,0,0,0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    searchVal(val) {
      this.list = this.staffList

      this.list = this.list.filter(data => {
        return !val || !data || data.nickname.indexOf(val) !== -1 || data.loginCode.indexOf(val) !== -1
      })

      // 补余
      if (this.list.length % 3 === 2) {
        this.list.push('')
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.isLoading = true
      this.dataReady = false
      this.$api.staff.getStaffList({
        loginCode: '',
        nickName: ''
      }).then(res => {
        this.isLoading = false
        this.staffList = res.data.accounts || []
        this.limitVo = res.data.limitVo

        // 补余
        if (this.staffList.length % 3 === 2) {
          this.staffList.push('')
        }

        this.list = this.staffList
        this.dataReady = true
      }).catch(() => {
        this.isLoading = false
        this.dataReady = false
      })
    },
    addUser() {
      this.gtag('event', 'usr_add_staff_start')
      if (!this.limitVo.flag) {
        this.$message.error('门店员工数量已达上限')
        return
      }
      // this.getStaffOauth(this.$store.getters.accountInfo.mobile, 'create')

      this.isShowAddUser = true
      this.dialogStatus = 'create'
    },
    checkStaffInfo(item) {
      if (!item) return
      this.currStaffInfo = item
      this.isShowStaffInfo = true
    },
    /** 已废弃 */
    getStaffInfo() {
      return new Promise((resolve) => {
        this.$api.staff.getStaffInfo().then(res => {
          this.staffData = res.data
          resolve(res)
        }).catch(() => {

        })
      })
    },
    getStaffOauth(loginCode, type) {
      return new Promise((resolve) => {
        this.isLoading = true
        this.$api.staff.getStaffOauth(loginCode).then(res => {
          this.staffData = res.data
          this.isLoading = false

          this.$nextTick(() => {
            // this.isShowAddUser = true
            // this.dialogStatus = type
          })
          resolve(this.staffData)
        }).catch(() => {
          this.isLoading = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-wrap {
  width: 100% !important;

  .empty {
    width: auto;
    height: 200px;
    margin: 30px auto;
  }
}

.add-container {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  .add-btn {
    margin-left: 10px;

    @include btn_page_primary('color');
  }
}

.search-input {
  width: 197px;
  height: 40px;
  margin-top: 10px;

  /deep/ .el-input__inner {
    border: none;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-radius: 0;
    // padding: 0;
    @include border_color_page_primary("color");
  }

  /deep/ .el-input__prefix {
    font-size: 20px;
  }

  // 更改clear图标
  /deep/ .el-input__suffix {
    .el-icon-circle-close {
      font-size: 20px;

      &::before {
        content: "\e6db";
      }

      @include color_page_primary("color");
    }
  }
}

.user-list {
  flex-wrap: wrap;
  padding: 30px 0;

  li {
    width: 384px;
    margin-bottom: calc((#{$pageInnerWidth} - 384px*3) / 2);
  }

  .user-item {
    width: 100%;
    height: 79px;
    border-radius: 4px;
    cursor: pointer;

    .info-wrap {
      flex: 1;
      width: 0;
      padding-right: 8px;

      .info-title {
        word-break: break-all;
      }

      .user-name {
        // flex: 1;
        font-weight: 500;
        font-size: 18px;
      }

      .role {
        padding: 0 4px;
        margin-left: 8px;
        border-radius: 4px;
        font-size: 14px;
        color: #906425;
        background-color: $color-yellow;
      }

      .phone {
        margin-top: 4px;
        font-weight: 300;
        font-size: 16px;
        color: #aeaeae;
      }
    }

    .user-avatar-wrap {
      width: 50px;
      height: 50px;
      margin: 0 16px;
      border-radius: 50%;
      color: #fff;

      .user-avatar {
        font-size: 24px;
      }

      @include background_color_page_primary('user-bg');
    }

    @include background_color_page_primary('bg-color-light');
  }
}

/deep/ .el-tabs__content {
  min-height: 300px;
}

.permission-list-wrap {
  border: 1px solid #ebeef5;

  .permission-item {
    + .permission-item {
      border-top: 1px solid #ebeef5;
    }
  }

  .role-name {
    width: 100px;
    font-weight: 600;
    text-align: center;
  }

  .app-wrap {
    flex: 1;
    border-left: 1px solid #ebeef5;

    .app-item {
      display: inline-block;
      width: 20%;
      padding: 8px 12px;
      // border-bottom: 1px solid #ebeef5;
      // border: 1px solid #ebeef5;
      line-height: 1.8;
    }
  }
}
</style>
